import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ConfidentialitePage() {
  useEffect(() => {
    document.title = 'Politique de confidentialité — HASPICA Studio de Design Bordeaux';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />

      <main className="pt-36 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          <p className="text-xs font-semibold text-neutral-400 uppercase tracking-widest mb-5">Juridique</p>
          <h1 className="font-heading text-4xl md:text-5xl text-neutral-900 font-light mb-12">
            Politique de confidentialité
          </h1>

          <div className="space-y-10 text-sm text-neutral-600 leading-relaxed">
            <section>
              <h4 id="collecte" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#collecte">1. Données collectées</a>
              </h4>
              <p>
                Dans le cadre de l'utilisation du formulaire de contact présent sur ce site, HASPICA peut être amené à collecter les données personnelles suivantes :
              </p>
              <ul className="mt-4 space-y-2 pl-4 border-l border-neutral-200">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Message et description du projet</li>
              </ul>
            </section>

            <section>
              <h4 id="utilisation" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#utilisation">2. Utilisation des données</a>
              </h4>
              <p>
                Les données personnelles collectées sont utilisées <strong className="text-neutral-800">uniquement pour répondre aux demandes</strong> formulées via le formulaire de contact. Elles permettent à HASPICA d'analyser les besoins exprimés et d'apporter une réponse adaptée à chaque demande de projet de design graphique ou d'identité visuelle.
              </p>
            </section>

            <section>
              <h4 id="partage" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#partage">3. Partage des données</a>
              </h4>
              <p>
                Les données personnelles collectées ne sont <strong className="text-neutral-800">ni vendues, ni partagées</strong> avec des tiers. Elles sont traitées de manière confidentielle et strictement réservées à l'usage interne de HASPICA.
              </p>
            </section>

            <section>
              <h4 id="conservation" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#conservation">4. Conservation des données</a>
              </h4>
              <p>
                Les données sont conservées uniquement le temps nécessaire au traitement de la demande, conformément aux dispositions légales applicables en France.
              </p>
            </section>

            <section>
              <h4 id="droits" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#droits">5. Vos droits (RGPD)</a>
              </h4>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants concernant vos données personnelles :
              </p>
              <ul className="mt-4 space-y-2 pl-4 border-l border-neutral-200">
                <li>Droit d'accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit à l'effacement (droit à l'oubli)</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit à la portabilité</li>
                <li>Droit d'opposition</li>
              </ul>
              <p className="mt-4">
                Pour exercer ces droits, contactez-nous à l'adresse :{' '}
                <a href="mailto:patr1khaspica@inbox.eu" rel="nofollow" className="text-neutral-900 underline hover:no-underline">
                  patr1khaspica@inbox.eu
                </a>
              </p>
            </section>

            <section>
              <h4 id="cookies" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#cookies">6. Cookies</a>
              </h4>
              <p>
                Ce site n'utilise pas de cookies à des fins de suivi publicitaire ou analytique. Des cookies techniques peuvent être utilisés pour assurer le bon fonctionnement du site.
              </p>
            </section>

            <section>
              <h4 id="contact-rgpd" className="font-heading text-xl text-neutral-900 font-medium mb-4">
                <a href="#contact-rgpd">7. Contact</a>
              </h4>
              <p>
                Pour toute question relative à la protection de vos données personnelles, contactez HASPICA à l'adresse :{' '}
                <a href="mailto:patr1khaspica@inbox.eu" rel="nofollow" className="text-neutral-900 underline hover:no-underline">
                  patr1khaspica@inbox.eu
                </a>
              </p>
            </section>

            <p className="text-xs text-neutral-400 border-t border-neutral-200 pt-6">
              Dernière mise à jour : mars 2026
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
